<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app" :class="vueAppClasses">
    <div class="notification-container">
      <VxSynchronizationAlerts v-for="(item, index) in notifications" :key="index" :message="item.message"
        :type="item.type" :countdown="item.countdown" @close="removeNotification(index)"
        :zIndex="99999999999999999 - index" :progress="item.percentage" />
    </div>

    <vs-prompt title="Please confirm the start of data synchronization" class="holamundo"
      @cancel="laterSynchNotification" @accept="acceptSynchNotification" accept-text="Start Now" cancel-text="Later"
      @close="closeSynchNotification" :active.sync="synchInfo.isShow">
      <div>
        <p>
          Applying the changes requires synchronization with the devices.
          the estimated time is <span class="minute-text">{{ Math.floor(synchInfo.countdown) }}:00</span> minutes.
          Select "Start Now" to begin the process or "Later" to postpone.
        </p>
      </div>
    </vs-prompt>

    <vs-popup class="holamundo notif__part" title="Alarm event" :active.sync="notif_popup">
      <Notification v-if="notif_data" :propsData="notif_data" @closeConfirmPopup="notif_popup = false" />
    </vs-popup>
    <vs-popup class="holamundo notif_list_part" title="Alarm event" :active.sync="notif_list_popup">
      <NotificationsList v-if="notif_list_data.data.length" @close_notif_popup="notif_list_popup = false"
        :propsData="notif_list_data" />
    </vs-popup>

    <vs-popup class="holamundo notif_list_part" title="Error message" :active.sync="errorPopup">
      <ErrorMessage v-if="errorPopup" :message="errorData" />
    </vs-popup>

    <router-view @setAppClasses="setAppClasses" />

    <vs-prompt title="Request To Connect" class="holamundo allow-connection" @cancel="laterSynchNotification"
      @accept="confirmConnection" accept-text="Confirm" cancel-text="Reject" @close="rejectConnection"
      :active.sync="requestToConnect.show">
      <div>
        <p>
          Request to connect a technical support specialist to your account. During the connection, you will be in
          observer mode and will not be able to change settings
          You can terminate the connection and revoke the authorization at any time.
          Allow connection?
        </p>
      </div>
    </vs-prompt>

    <div>
      <BlockScreenModal />
    </div>
    <div class="modal-container" v-if="isConnectionStart">
      <transition name="slide">
        <div v-if="isOpen" class="modal">
          <p>When you want to disconnect, press here</p>
          <button class="disconnect-button" @click="confirmDisconnectionModal = true">Disconnect</button>
        </div>
      </transition>
      <vs-button icon-pack="feather" @click="toggleModal" :icon="isOpen ? 'icon-arrow-right' : 'icon-arrow-left'"
        class=" toggle-button shadow-lg btn-back-to-top" />
    </div>

    <vs-prompt title="Request To Connect" :class="'footer-hide'" :active.sync="confirmDisconnectionModal" hide-footer>
      <div>
        <p>
          Request to connect a technical support specialist to your account. During the connection, you will
          be in
          observer mode and will not be able to change settings
          You can terminate the connection and revoke the authorization at any time.
          Allow connection?
        </p>
      </div>
      <div class="detail_actions">
        <vs-button class="unimacs_button" @click="confirmDisconnectionModal = false">Continue</vs-button>
        <vs-button class="unimacs_cancel_button mr-3 ml-4" @click="disconnectionModal">Disconnect</vs-button>
      </div>
    </vs-prompt>

    <vs-prompt title="The connection with technical support is complete" :class="'footer-hide'"
      :active.sync="adminDisconnectConnecting" hide-footer>
      <div :class="'footer-hide-body'">
        <h5> A technical support specialist has completed the connection session. </h5>
        <h5> Access to the account features has been restored. </h5>
        <h5> we wish you a pleasant usage! </h5>
      </div>
      <div class="detail_actions">
        <vs-button class="unimacs_button" @click="adminDisconnectConnectingConfirm">Ok</vs-button>
      </div>
    </vs-prompt>

    <vs-prompt title="Connection session terminated" :class="'footer-hide'" :active.sync="isReconnectModal"
      @close="ReconnectModal_Cancel" hide-footer>
      <div :class="'footer-hide-body'">
        <h5> A technical support specialist has completed the connection session. </h5>
        <h5> Access to the account features has been restored. </h5>
        <h5> we wish you a pleasant usage! </h5>
      </div>
      <div class="detail_actions">
        <vs-button class="unimacs_cancel_button mr-3 ml-4" @click="ReconnectModal_Reconnect">Reconnect</vs-button>
        <vs-button class="unimacs_button" @click="ReconnectModal_Cancel">Cancel</vs-button>
      </div>
    </vs-prompt>


  </div>
</template>

<script>
import themeConfig from "@/../themeConfig.js";
import jwt from "@/http/requests/auth/jwt/index.js";
import Notification from "./Notification";
import NotificationsList from "./NotificationsList";
import ErrorMessage from "./ErrorMessage";
import BlockScreenModal from "./BlockScreenModal.vue";
import axios from "./http/axios";
import VxSynchronizationAlerts from "./components/synchronization-alerts/VxSynchronizationAlerts.vue";

export default {
  components: {
    Notification,
    NotificationsList,
    ErrorMessage,
    BlockScreenModal,
    VxSynchronizationAlerts
  },
  sockets: {
    connect: function () { },
  },
  data() {
    return {
      isReconnectModal: false,
      isConnectionStart: false,
      adminDisconnectConnecting: false,
      confirmDisconnectionModal: false,
      isOpen: true,
      supportCanceled: false,
      requestToConnect: { show: false },
      vueAppClasses: [],
      notifications: null,
      notif_popup: false,
      notif_data: null,
      synchInfo: { isShow: false },
      errorData: null,
      errorPopup: false,
      notif_list_popup: false,
      notif_list_data: {
        data: [],
        count: 0,
      },
      startSupported: null,
      isDisabledItems: false
    };
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    },
    "$store.state.isDisabledAllFields"(val) {
      this.toggleIsDisabledItems(val);
    },
    "$store.state.synchronizationNotifications"(val) {
      this.synchNotification(val);
    },
    "$store.state.showPopupNotification"(val) {
      this.showPopupNotification(val);
    },
    "$vs.rtl"(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
    },
    "$store.state.requestToConnect"(val) {
      this.requestToConnectModal(val);
    },
    "$store.state.isSupported"(val) {
      const user = localStorage.user ? JSON.parse(localStorage.user) : null;
      if (user && user.company) {
        this.subscribeRequestToConnectSockets(user)
      }
    },
    "$store.state.adminConnect"(val) {
      this.handleStorageChange_ADMIN(val);
    },
    "$store.state.startConnection"(val) {
      this.isConnectionStart = val;
      if (val) {
        this.startSupported = val;
      }
    },
    "$store.state.connectSocket_ADMIN"(val) {
      if (val) {
        this.checkConnectionStart_ADMIN()
      }
    },
  },
  computed: {
    themeColor() {
      return this.$store.state.theme;
    },
  },
  methods: {

    confirmDisconnection() {
      this.confirmDisconnectionModal = true;
    },

    disconnectionModal() {
      this.$vs.loading({
        type: "corners",
      });

      this.isConnectionStart = false
      const company_info = localStorage.company_data ? JSON.parse(localStorage.company_data) : null
      const res = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data")) : null;
      if (!company_info && !res) { return false }
      if (res.expire_time) {
        this.$store.dispatch("disconnectSupportOverView", { id: res.id }).then((response) => {
          this.$vs.loading.close();
          this.$store.commit("SET_MODAL_CONNECTION", { show: false });
          this.rollbackToken_ADMIN();
          setTimeout(() => {
            this.removeDataFromStorage();
          }, 100)
        })
        return true;
      }
      this.$vs.loading.close();
      this.$store.dispatch("disconnectSupport", { id: res.id, company: company_info.id }).then(() => {
        this.rollbackToken_ADMIN();
        setTimeout(() => {
          this.removeDataFromStorage();
        }, 100)
      })

      this.$vs.loading.close();

      return true;
    },

    toggleModal() {
      this.isOpen = !this.isOpen;
    },

    laterSynchNotification() {
      const user = localStorage.user ? JSON.parse(localStorage.user) : null
      if (!user) { return false }
      this.$store.dispatch("disconnectSupport", { id: user.id, company: user.company })
    },
    requestToConnectModal(val) {
      return this.requestToConnect = val;
    },
    confirmConnection() {
      const res = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data")) : null;
      if (!res) { return false }
      axios
        .post(`/confirmSupport`, {
          token: res.token
        }, {
          headers: { Authorization: localStorage.token },
        })
        .then((res) => {
          if (res.data) {
            this.$store.commit("SET_START_SUPPORTING", {
              support: true,
              enabled: true
            })

          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$store.commit("SET_START_SUPPORTING", null)

        })


    },
    rejectConnection() {
      const user = localStorage.user ? JSON.parse(localStorage.user) : null
      if (!user) { return false }
      this.$store.dispatch("disconnectSupport", { id: user.id, company: user.company })
      this.$store.commit("SET_MODAL_CONNECTION", { show: false });
      this.$store.dispatch("disconnectSupport", { id: user.id, company: user.company })
      this.$store.commit("SET_MODAL_CONNECTION", { show: false });
    },
    subscribeSockets(user) {
      if (!this.$socket || !this.$socket.$subscribe) {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "Something Went Wrong",
        });
        window.location.reload();
      }
      this.$socket.client.emit("subscribe", `toasts/${user.company}`);
      this.$socket.$subscribe(
        `sync_status_update/${user.company}`,
        (payload) => {
          this.$store.commit("SET_SYNCH_NOTIFICATIONS", null);
          const res = JSON.parse(payload)
          setTimeout(() => {
            this.$store.commit("SET_SYNCH_NOTIFICATIONS", res);
            if (res.acu && window.location.pathname === "/device") {
              for (let element in res.acu) {
                const data = {
                  id: element
                }
                if (res.acu[element].failed) {
                  data.text = `Fault ${res.acu[element].percentage}% `
                } else {
                  if (res.acu[element].percentage < 100) {
                    data.text = `Syncing ${res.acu[element].percentage} %`
                  } else {
                    data.text = "Synced"
                  }
                }
                this.$store.commit("accessPoint/UPDATE_ACU_SYNCH_STATUS", data);
              }
            }
          }, 20)
          // clearTimeout(timer)
        }
      );

      this.$socket.$subscribe(
        `sync_message/${user.company}`,
        (payload) => {
          const res = JSON.parse(payload)
          this.$vs.notify({
            time: 7000,
            color: res.success ? "success" : "danger",
            title: res.message,
          });
        })
      this.$socket.$subscribe(
        `toasts/${user.company}`,
        (payload) => {
          const res = JSON.parse(payload)
          this.$vs.notify({
            time: 7000,
            color: "danger",
            title: res.message,
          });
        })
    },
    synchNotification(val) {
      this.notifications = null
      if (val) {
        this.notifications = val;
      }
    },
    closeSynchNotification() {
      this.$store.commit("SET_SYNCH_NOTIFICATIONS", null);
      this.synchInfo = false;
    },

    laterSynchNotification() {
      this.$store.dispatch("fetchSynchDataStartNow", 1).then(() => {
        this.$vs.notify({
          time: 7000,
          color: "success",
          title: "Synchronization Started",
        });

        this.closeSynchNotification()
      })
    },
    acceptSynchNotification() {
      this.closeSynchNotification()
      this.$store.dispatch("fetchSynchDataStartNow").then(() => {
        this.$vs.notify({
          time: 7000,
          color: "success",
          title: "Synchronization Started",
        });
      })
    },

    showPopupNotification(val) {
      this.synchInfo = val;
    },


    toggleClassInBody(className) {
      if (className === "dark") {
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
        document.body.classList.add("theme-dark");
      } else if (className === "semi-dark") {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
        document.body.classList.add("theme-semi-dark");
      } else {
        if (document.body.className.match("theme-dark")) {
          document.body.classList.remove("theme-dark");
        }
        if (document.body.className.match("theme-semi-dark"))
          document.body.classList.remove("theme-semi-dark");
      }
    },
    toggleIsDisabledItems(val) {
      this.isDisabledItems = val
    },
    removeNotification() {
      this.notifications = null;
      this.$store.commit("SET_SYNCH_NOTIFICATIONS", null);
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    handleWindowResize() {
      this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

      // Set --vh property
      document.documentElement.style.setProperty(
        "--vh",
        `${window.innerHeight * 0.01}px`
      );
    },
    handleScroll() {
      this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
    },
    getNotifs(params) {
      const user = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : null;

      if (user) {
        if (user.company && !user.package) {
        } else {
          this.$http
            .get(`notification`, {
              headers: { Authorization: localStorage.token },
              params,
            })
            .then((res) => {
              this.notif_lists = [];

              if (res.data.data.length) {
                res.data.data.forEach((item) => {
                  const time_zone =
                    item.access_points && "time_zone" in item.access_points
                      ? item.access_points.time_zone
                      : null;
                  const time = Intl.DateTimeFormat().resolvedOptions().timeZone;
                  var isFirefox = typeof InstallTrigger !== "undefined";
                  var isSafari =
                    navigator.vendor &&
                    navigator.vendor.indexOf("Apple") > -1 &&
                    navigator.userAgent &&
                    navigator.userAgent.indexOf("CriOS") == -1 &&
                    navigator.userAgent.indexOf("FxiOS") == -1;
                  var is_OSX = /(Mac|iPhone|iPod|iPad)/i.test(
                    navigator.platform
                  );
                  let correct_date;
                  if (isFirefox || isSafari || is_OSX) {
                    const local = this.$moment
                      .utc(item.createDate, "YYYY-MM-DD HH:mm:ss")
                      .tz(time_zone ? time_zone : time);
                    const momentFormat = this.$moment(
                      local,
                      "YYYY-MM-DD HH:mm:ss"
                    ).format("YYYY-MM-DD HH:mm:ss");
                    correct_date = momentFormat;
                    if (item.confirmed) {
                      const confirmedLocal = this.$moment
                        .utc(new Date(+item.confirmed), "YYYY-MM-DD HH:mm:ss")
                        .tz(time_zone ? time_zone : time);
                      const momentFormat = this.$moment(
                        confirmedLocal,
                        "YYYY-MM-DD HH:mm:ss"
                      ).format("YYYY-MM-DD HH:mm:ss");
                      item.confirmed = momentFormat;
                    }
                  } else {
                    correct_date = this.$moment(item.createDate)
                      .tz(time_zone ? time_zone : time)
                      .format(`YYYY-MM-DD HH:mm:ss`);

                    if (item.confirmed) {
                      item.confirmed = this.$moment(new Date(+item.confirmed))
                        .tz(time_zone ? time_zone : time)
                        .format(`YYYY-MM-DD HH:mm:ss`);
                    }
                  }
                  item.createDate = correct_date;
                });
              }

              this.notif_list_data = res.data;
              this.notif_popup = false;
              this.notif_list_popup = true;
            });
        }
      }
    },


    adminDisconnectConnectingConfirm() {
      this.adminDisconnectConnecting = false;
      window.location.reload();
    },
    subscribeRequestToConnectSockets(user) {
      if (this.$socket && this.$socket.$subscribe) {
        const isShow = localStorage.getItem("showPopup");
        if (!isShow) {
          this.$socket.$subscribe(
            `company_support/${user.company}`,
            (payload) => {
              const res = JSON.parse(payload)
              localStorage.setItem("user_data", JSON.stringify(res));
              this.$store.commit("SET_MODAL_CONNECTION", { show: true });
            })
          const res = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data")) : null;
          if (!res || !res.id) {
            return
          }
          this.$socket.client.emit("subscribe", `company_support/0/r_${res.id}`);
          this.$socket.$subscribe(
            `company_support/0/r_${res.id}`,
            (payload) => {
              this.$store.commit("SET_MODAL_CONNECTION", { show: false });
              this.$store.commit("SET_START_SUPPORTING", null);
              localStorage.removeItem("user_data");
              // this.$vs.loading.close();
              this.adminDisconnectConnecting = true;

            })

          this.$socket.client.emit("subscribe", `company_support/${user.company}/r_${res.id}`);
          this.$socket.$subscribe(
            `company_support/${user.company}/r_${res.id}`,
            (payload) => {
              this.$store.commit("SET_MODAL_CONNECTION", { show: false });
              this.$store.commit("SET_START_SUPPORTING", null);
              localStorage.removeItem("user_data");
              // this.$vs.loading.close();
              this.adminDisconnectConnecting = true;

            })


        }

      } else {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "Something Went Wrong",
        });
        window.location.reload();
      }
    },

    updateToken_ADMIN(newToken) {
      const currentToken = localStorage.getItem("token");
      const currentPermissions = localStorage.getItem("permissions");
      const currentSettings = localStorage.getItem("settings");
      const currentUser = localStorage.getItem("user");

      localStorage.setItem("oldToken", currentToken);
      localStorage.setItem("oldSettings", currentSettings);
      localStorage.setItem("oldPermissions", currentPermissions);
      localStorage.setItem("oldUser", currentUser);

      setTimeout(() => {
        localStorage.setItem("token", newToken);
      }, 110)

    },

    rollbackToken_ADMIN() {
      this.$store.commit("SET_ADMIN_START_CONNECT", false);
      this.isReconnectModal = false
      const oldToken = localStorage.getItem("oldToken");
      const oldSettings = localStorage.getItem("oldSettings");
      const oldPermissions = localStorage.getItem("oldPermissions");
      const oldUser = localStorage.getItem("oldUser");

      localStorage.setItem("settings", oldSettings);
      localStorage.setItem("permissions", oldPermissions);
      localStorage.setItem("token", oldToken);
      localStorage.setItem("user", oldUser);

      sessionStorage.clear();
    },

    removeDataFromStorage() {
      this.$vs.loading({
        type: "corners",
      });
      localStorage.removeItem("oldToken");
      localStorage.removeItem("user_data");
      localStorage.removeItem("company_data");
      localStorage.removeItem("oldSettings");
      localStorage.removeItem("oldPermissions");
      localStorage.removeItem("isConnectionStart");
      localStorage.removeItem("oldUser");
      setTimeout(() => {
        this.$vs.loading.close();
        window.location.href = "/companies";
      }, 800)

    },

    ReconnectModal_Reconnect() {
      this.$vs.loading({
        type: "corners",
      });
      const companyInfo = JSON.parse(localStorage.getItem("company_data"));
      sessionStorage.removeItem("pageRefreshed");
      axios
        .put(`/company/support`, {
          company: companyInfo.id,
        }, {
          headers: { Authorization: localStorage.token },
        })
        .then((res) => {
          if (res.data) {
            localStorage.setItem("user_data", JSON.stringify(res.data));
            this.$store.commit("SET_ADMIN_CONNECT", res.data);
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
        })
    },
    ReconnectModal_Cancel() {
      this.$vs.loading({
        type: "corners",
      });
      localStorage.removeItem("isConnectionStart");
      this.$store.commit("SET_MODAL_CONNECTION", { show: false });
      this.isReconnectModal = false;
      this.$vs.loading.close();
      this.removeDataFromStorage()

    },

    checkConnectionStart_ADMIN() {
      const res = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data")) : null;
      if (res) {

        this.$socket.client.emit("subscribe", `company_support/0/${res.token}`);
        this.$socket.$subscribe(
          `company_support/0/${res.token}`,
          (payload) => {
            const data = JSON.parse(payload)
            this.updateToken_ADMIN(data.token.token);
            localStorage.setItem("isConnectionStart", true);
            this.$vs.loading({
              type: "corners",
            });

            setTimeout(() => {
              this.$vs.loading.close();
              this.startSupported = true;
              this.$store.commit("SET_ADMIN_START_CONNECT", true);
              sessionStorage.setItem("userConfirmedConnection", "true");
              window.location.reload();
            }, 500)
          })

        this.$socket.client.emit("subscribe", `company_support/0/r_${res.id}`);
        this.$socket.$subscribe(
          `company_support/0/r_${res.id}`,
          () => {

            this.$store.commit("SET_ADMIN_START_CONNECT", false);
            this.rollbackToken_ADMIN()
            this.isReconnectModal = true;

          })
      }

    },
    handleStorageChange_ADMIN(event) {
      const isAdmin = localStorage.getItem("showPopup");
      if (event.id && isAdmin) {
        this.checkConnectionStart_ADMIN(); // React to changes in the key
      }
    },
  },

  mounted() {
    this.toggleClassInBody(themeConfig.theme);
    this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    const startConnection = localStorage.getItem("isConnectionStart");
    this.isConnectionStart = startConnection;
    // this.showPopupNotification(this.$store.state.showPopupNotification);
    this.showPopupNotification(false);
    this.$root.$on("openNotif", (data) => {
      this.notif_data = data;
      this.notif_popup = true;
    });
    const user = localStorage.user ? JSON.parse(localStorage.user) : null;
    if (user && user.company) {
      // this.$vs.loading({
      //   type: "corners",
      // });

      this.subscribeRequestToConnectSockets(user);
      this.subscribeSockets(user);

      // setTimeout(() => {
      //   this.$vs.loading.close();
      // }, 10)
    }
    const isShow = localStorage.getItem("showPopup");
    const userData = localStorage.getItem("user_data");

    if (isShow && sessionStorage.getItem("pageForceRefreshed") && userData) {

      this.checkConnectionStart_ADMIN()
    }
    if (!sessionStorage.getItem("pageForceRefreshed") && sessionStorage.getItem("userConfirmedConnection")) {
      sessionStorage.setItem("pageForceRefreshed", "true");
      setTimeout(() => {
        this.$vs.notify({
          time: 7000,
          color: "danger",
          title: "Something Went Wrong",
        });
        location.reload(); // Refresh the page
      }, 600)
    }
    this.$vs.loading.close();
  },

  async created() {
    // this.$vs.loading({
    //   type: "corners",
    // });
    localStorage.setItem("disable_notifs", false);

    // jwt
    jwt.init();
    const dir = this.$vs.rtl ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);

    window.addEventListener("resize", this.handleWindowResize);
    window.addEventListener("scroll", this.handleScroll);

    if (this.themeColor) {
      setTimeout(() => {
        this.toggleClassInBody(this.themeColor);
      }, 0);
    }
    this.notifications = null;

    const user = localStorage.user ? JSON.parse(localStorage.user) : null;

    if (user && user.company) {
      if (!user.cardholder && this.$socket) {
        this.$socket.$subscribe(`notification/${user.company}`, (payload) => {
          const socket_data = JSON.parse(payload);
          this.notif_data = socket_data;
          const disable_notif = localStorage.getItem("disable_notifs");
          if (this.$route.name !== "page-login" && disable_notif !== "true") {
            this.notif_popup = true;
          }
          this.$root.$emit("push_notification", socket_data);
        });
      }
    }
    this.$vs.loading.close();
    this.$root.$on("view_all_notifs", () => {
      const params = {
        page: 1,
        page_items_count: 10,
      };
      this.getNotifs(params);
    });
  },

  destroyed() {
    window.removeEventListener("resize", this.handleWindowResize);
    window.removeEventListener("scroll", this.handleScroll);
    this.notifications = null;


  },
};
</script>

<style lang="scss">
.allow-connection {
  .vs-dialog {
    max-width: 500px !important;

    .vs-dialog-text {
      padding: 24px !important;
    }
  }
}

:root {
  --select-border: #777;
  --select-focus: blue;
  --select-arrow: var(--select-border);
}

.notif__part.vs-popup-primary,
.notif__part {
  display: none;
  z-index: 99999999999999;
}

.notif__part {
  left: auto !important;
  right: 0px !important;
  width: 800px !important;

  .vs-popup--background {
    background: none !important;
  }
}


.notif__part .vs-popup {
  position: absolute;
  top: 15px;
  right: 15px;
}

.notif_list_part.vs-popup-primary {
  z-index: 1000000000;
}

.notif_list_part .vs-popup {
  width: 1000px !important;
}

.notif_list_part .vs-popup--content {
  max-height: 75vh;
}

.custom_select_tag {
  // A reset of styles, including removing the default dropdown arrow
  appearance: none;
  background-color: transparent;
  border: none;
  padding: 0 1em 0 0;
  margin: 0;
  width: 100%;
  font-family: inherit;
  font-size: inherit;
  cursor: inherit;
  line-height: inherit;

  // Stack above custom arrow
  z-index: 1;

  // Remove dropdown arrow in IE10 & IE11
  // @link https://www.filamentgroup.com/lab/select-css.html
  &::-ms-expand {
    display: none;
  }

  // Remove focus outline, will add on alternate element
  outline: none;
}

.custom_select {
  display: grid;
  grid-template-areas: "select";
  align-items: center;
  position: relative;

  .custom_select_tag,
  &::after {
    grid-area: select;
  }

  min-width: 15ch;
  max-width: 30ch;

  border: 1px solid var(--select-border);
  border-radius: 0.25em;
  padding: 0.25em 0.5em;

  font-size: 1.25rem;
  cursor: pointer;
  line-height: 1.1;

  // Optional styles
  // remove for transparency
  background-color: #fff;
  background-image: linear-gradient(to top, #f9f9f9, #fff 33%);

  // Custom arrow
  &:not(.select--multiple)::after {
    content: "";
    justify-self: end;
    width: 0.8em;
    height: 0.5em;
    background-color: var(--select-arrow);
    clip-path: polygon(100% 0%, 0 0%, 50% 100%);
  }
}

// Interim solution until :focus-within has better support
.custom_select_tag:focus+.custom_focus {
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border: 2px solid var(--select-focus);
  border-radius: inherit;
}

.select--disabled {
  cursor: not-allowed;
  background-color: #eee;
  background-image: linear-gradient(to top, #ddd, #eee 33%);
}

.custom_select+label {
  margin-top: 2rem;
}

.vs-component.con-vs-dialog.vs-dialog-danger {
  z-index: 5555555555 !important;
}

.modal-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  z-index: 999920999999;
  background-color: #fff;
  border-radius: 8px;
  height: 40px;

  .toggle-button {
    height: 60px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
    background-color: #fff !important;
    border: 1px solid #777 !important;
    border: none;
    // border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
  }

  .modal {
    padding: 0px 20px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 10px;

    p {
      margin: 0;
      font-size: 14px;
      color: #333;
    }

    .disconnect-button {
      height: 35px;
      background-color: #e74c3c;
      color: white;
      border: none;
      border-radius: 8px;
      padding: 0 20px;
      cursor: pointer;
      font-size: 14px;
    }
  }
}

/* Slide Animation */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(100%);
}

.footer-hide {
  .vs-dialog {
    max-width: 500px !important;
    text-align: center;
  }

  .footer-hide-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .detail_actions {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  footer {
    display: none !important;
  }
}

.notification-container {
  position: absolute;
  top: 5px;
  right: 20px;
  z-index: 99999999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* Align notifications to the right */
}

.minute-text {
  color: aqua
}
</style>
